import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


export default function RequireMaster({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user){
  if (user?.role != 'master') {
    return <Navigate to="/gerar" state={{ from: loc }} replace />;
  }
  return children;
} else {
    return <Navigate to="/login" state={{ from: loc }} replace />;
}
}
